module.exports = __webpack_public_path__ + "img/package-minus.89bdd4c9.svg";